__turbopack_context__.v({
  "container": "Lino6W_container",
  "webLink": "Lino6W_webLink",
});
